function r(e, o) {
  return o.some(
    (s) => e.toLowerCase().includes(s.toLowerCase())
  );
}
export {
  r as messageHasKeywords
};
